'use client';

import { Analytics } from '@vercel/analytics/next';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { useEffect, useState } from 'react';
import { getConsent, onConsentChange } from '@/lib/analytics/consent';

/**
 * Loads Vercel Analytics + Speed Insights only after the user has accepted
 * analytics cookies. Vercel claims "cookieless", but it still sends pageview
 * pings and a session-bound identifier which DSGVO regulators treat as
 * consent-requiring. So we gate behind the analytics consent category.
 *
 * Also short-circuits when not running on Vercel (local dev) so the scripts
 * don't 404.
 */
export function VercelAnalytics() {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional one-shot mount sync / external store subscription
    setAllowed(!!getConsent()?.analytics);
    return onConsentChange((state) => {
      setAllowed(!!state?.analytics);
    });
  }, []);

  if (!process.env.NEXT_PUBLIC_VERCEL_ENV && process.env.NODE_ENV !== 'production') {
    return null;
  }

  if (!allowed) return null;

  return (
    <>
      <Analytics />
      <SpeedInsights />
    </>
  );
}
